export const generateId = () => Math.random().toString(36).substring(2, 15);

export const formatDate = (date) => {
  if (!date) return '-';
  const d = new Date(date);
  return d.toLocaleString('zh-CN');
};

export const formatDateShort = (date) => {
  if (!date) return '-';
  const d = new Date(date);
  return d.toLocaleDateString('zh-CN');
};

export const formatFileSize = (bytes) => {
  if (!bytes) return '-';
  if (bytes < 1024) return bytes + ' B';
  if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + ' KB';
  return (bytes / (1024 * 1024)).toFixed(2) + ' MB';
};

export const getStatusColor = (status) => {
  const map = {
    '主用': 'bg-emerald-100 text-emerald-800',
    '测试': 'bg-amber-100 text-amber-800',
    '草稿': 'bg-slate-100 text-slate-800',
    '废弃': 'bg-red-100 text-red-800',
    '未迁移': 'bg-slate-100 text-slate-800',
    '迁移中': 'bg-amber-100 text-amber-800',
    '已API化': 'bg-emerald-100 text-emerald-800',
    '保留链接': 'bg-blue-100 text-blue-800',
    '半迁移': 'bg-purple-100 text-purple-800',
    '已配置': 'bg-emerald-100 text-emerald-800',
    '未配置': 'bg-red-100 text-red-800',
    '已采纳': 'bg-emerald-100 text-emerald-800',
    '部分采纳': 'bg-blue-100 text-blue-800',
    '待审核': 'bg-amber-100 text-amber-800',
    '已拒绝': 'bg-red-100 text-red-800',
    '采纳': 'bg-emerald-100 text-emerald-800',
    '已完成': 'bg-emerald-100 text-emerald-800',
    '生成中': 'bg-amber-100 text-amber-800',
    '待生成': 'bg-slate-100 text-slate-800',
    '失败': 'bg-red-100 text-red-800',
    '已启用': 'bg-emerald-100 text-emerald-800',
    '已禁用': 'bg-slate-100 text-slate-800',
  };
  return map[status] || 'bg-slate-100 text-slate-800';
};

export const getModuleColor = (module) => {
  const map = {
    'Listing': 'bg-purple-100 text-purple-800',
    'Ads': 'bg-orange-100 text-orange-800',
    'Visual': 'bg-pink-100 text-pink-800',
    'QA': 'bg-cyan-100 text-cyan-800',
    '通用': 'bg-slate-100 text-slate-800',
  };
  return map[module] || 'bg-slate-100 text-slate-800';
};

export const getPromptTypeColor = (type) => {
  const map = {
    'System Prompt': 'bg-indigo-100 text-indigo-800',
    'Input Template': 'bg-sky-100 text-sky-800',
    'Output Template': 'bg-teal-100 text-teal-800',
    'Checker Prompt': 'bg-rose-100 text-rose-800',
    'Addon Rule': 'bg-slate-100 text-slate-800',
    'Workflow Prompt': 'bg-violet-100 text-violet-800',
    'Batch Prompt': 'bg-fuchsia-100 text-fuchsia-800',
    'API Prompt': 'bg-lime-100 text-lime-800',
  };
  return map[type] || 'bg-slate-100 text-slate-800';
};

export const getFileTypeIcon = (type) => {
  const map = {
    'PDF': '📄', 'Word': '📝', 'Doc': '📝', 'docx': '📝',
    'Excel': '📊', 'xlsx': '📊', 'CSV': '📊',
    'Markdown': '📑', 'md': '📑', 'TXT': '📃', 'txt': '📃',
    'HTML': '🌐', 'JSON': '⚙️',
    'PNG': '🖼️', 'JPG': '🖼️', 'WebP': '🖼️',
    'ZIP': '📦',
    'Link': '🔗',
  };
  return map[type] || '📎';
};

export const detectReportType = (fileName) => {
  const name = fileName.toLowerCase();
  if (name.includes('search term')) return 'Search Term Report';
  if (name.includes('campaign')) return 'Campaign Report';
  if (name.includes('targeting')) return 'Targeting Report';
  if (name.includes('placement')) return 'Placement Report';
  if (name.includes('business')) return 'Business Report';
  if (name.includes('advertised')) return 'Advertised Product Report';
  if (name.includes('purchased')) return 'Purchased Product Report';
  if (name.includes('budget')) return 'Budget Report';
  return 'Unknown Report';
};

export const validateReportFields = (headers) => {
  const required = ['Campaign','Ad Group','Targeting','Customer Search Term','Match Type','Impressions','Clicks','CTR','CPC','Spend','Sales','Orders','CVR','ACOS','ROAS'];
  const missing = required.filter(f => !headers.some(h => h.toLowerCase().includes(f.toLowerCase())));
  return { valid: missing.length === 0, missing, score: Math.round(((required.length - missing.length) / required.length) * 100) };
};

export const exportToCSV = (rows, headers, filename) => {
  const csv = [headers.join(','), ...rows.map(r => r.map(v => `"${String(v).replace(/"/g, '""')}"`).join(','))].join('\n');
  const blob = new Blob(['\ufeff' + csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url; a.download = filename; a.click();
};

export const sleep = (ms) => new Promise(r => setTimeout(r, ms));
